import { render } from "./CourseLearningList.vue?vue&type=template&id=00b8c824&scoped=true"
import script from "./CourseLearningList.vue?vue&type=script&lang=js"
export * from "./CourseLearningList.vue?vue&type=script&lang=js"

import "./CourseLearningList.vue?vue&type=style&index=0&id=00b8c824&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b8c824"]])

export default __exports__